import CityPageTemplate from "../city-template/CityPageTemplate";
import { yorkConfig } from "./data";

export default function YorkPage() {
  return <CityPageTemplate config={yorkConfig} />;
}